import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	customizeHelpCenter: {
		id: 'servicedesk-settings-customer-portal-v2.customize-help-center.customize-help-center',
		defaultMessage: 'Customize your help center',
		description: 'Header on the JSM project settings page for customizing help center',
	},
	customizeHelpCenterMessage: {
		id: 'servicedesk-settings-customer-portal-v2.customize-help-center.customize-help-center-message',
		defaultMessage:
			'Manage announcements and messages, and customize the branding and layout of your help center. Customization options are available only to Jira administrators.',
		description: 'Message for the JSM project settings page for customizing help center',
	},
	customizeHelpCenterLink: {
		id: 'servicedesk-settings-customer-portal-v2.customize-help-center.customize-help-center-link',
		defaultMessage: 'See help center customization options',
		description: 'Link on the JSM project settings page for customizing help center',
	},
});
